module.exports = __webpack_public_path__ + "static/img/11bg_7.08df53f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/11bg_7.png
// module id = 635
// module chunks = 1